import { t, Trans } from "@lingui/macro";
import { Box, Typography, Button } from "@mui/material";
import { AutoSelectTextField } from "@WahooFitness/redesignr";
import { useEffect, useState } from "react";

function DuplicateWorkoutProfileDrawer({
  duplicateProfileNameRef,
  profileName,
  handleCancel,
  error,
  handleKeyPress,
  handleSave,
  checkValid,
}: {
  duplicateProfileNameRef: React.Ref<HTMLInputElement>;
  profileName?: string;
  handleCancel: () => void;
  handleSave: () => void;
  checkValid: (value: string) => void;
  handleKeyPress: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  error: string | undefined;
}) {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (profileName) {
      const suffix = profileName.match(/\s*\((\d+)\)$/);
      const base = suffix ? profileName.slice(0, -suffix[0].length) : profileName;
      const count = suffix ? +suffix[1] + 1 : 2;

      setValue(`${base} (${count})`);
    }
  }, [profileName]);

  return (
    <Box display="flex" flexDirection="column">
      <Box display="flex" flexDirection="column" gap={1} alignItems="center" px={4} pb={3} pt={4}>
        <Typography variant="prose-lg-medium">
          <Trans>Duplicate &quot;{profileName}&quot;</Trans>
        </Typography>
        <Typography variant="prose-base">
          <Trans>Give this workout a new profile name</Trans>
        </Typography>
      </Box>
      <Box display="flex" flexDirection="column" p={3}>
        <AutoSelectTextField
          inputRef={duplicateProfileNameRef}
          fullWidth
          variant="outlined"
          label={t`Profile name`}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            checkValid(e.target.value);
          }}
          onKeyUp={handleKeyPress}
          error={!!error}
          helperText={error}
          inputProps={{ maxLength: 30 }}
          onContextMenu={(event) => {
            event.preventDefault();
          }}
        />
      </Box>
      <Box display="flex" flexDirection="row" p={3} gap={1.5}>
        <Button variant="outlined" size="large" fullWidth onClick={handleCancel}>
          <Trans>Cancel</Trans>
        </Button>
        <Button variant="contained" size="large" fullWidth onClick={handleSave}>
          <Trans>Duplicate</Trans>
        </Button>
      </Box>
    </Box>
  );
}

export default DuplicateWorkoutProfileDrawer;
